import config from '@/config'
import lang from '@/lang'

import { revenueStates } from '@/modules/base/util/constants'

const urlPrefix = `${config.resourceHost}revenue`
const listSettingUrl = `${config.resourceHost}setting/userlist/revenue`

const {
  OPEN,
  PAID,
  PARTIALLYPAID,
  DRAFT,
  TO_ANALYZE,
  ANALYZE_ERROR,
} = revenueStates

export const urls = {
  resource: urlPrefix,
  listSetting: listSettingUrl,
  sort: `${listSettingUrl}/sort`,
  columns: `${listSettingUrl}/columns`,
  multiple: 'revenues',
}

const resourceUrl = `${config.resourceHost}revenue`

export default {
  urls,
  receiptBaseUrl: config.resourceHost,
  receiptUrl: `${resourceUrl}/receipt`,
  searchUrl: `${resourceUrl}/search`,

  revenueListSetting: listSettingUrl,
  defaultReceiptNumber: '-',

  routes: {
    details: '/revenue',
    list: `${config.resourceHost}${urls.multiple}`,
    listView: `/${urls.multiple}`,
    new: '/revenue/new',
    edit: id => `/revenue/edit/${id}`,
  },

  ocrFieldSelectOptions: [
    { label: lang.receipt.form.payee.label, value: 'sender', hiddenIfPaid: true },
    { label: lang.receipt.form.receiptNumber, value: 'receiptNumber', hiddenIfPaid: false },
    { label: lang.receipt.form.date, value: 'date', hiddenIfPaid: true },
    { label: lang.receipt.form.description, value: 'description', hiddenIfPaid: false },
    { label: 'Betrag', value: 'priceTotal', hiddenIfPaid: false },
  ],

  fineUploader: {
    messages: {
      minSizeError: lang.expenseFileMinSizeError,
      sizeError: lang.expenseFileMaxSizeError,
      typeError: lang.expenseFileTypeError,
    },
    validation: {
      acceptFiles: ['image/jpg', 'image/jpeg', 'image/png', 'application/pdf'],
      allowedExtensions: ['jpg', 'jpeg', 'pdf', 'png'],
      sizeLimit: 25 * 1024 * 1024, // 25 mb
    },
    scaling: {
      sendOriginal: false,
      sizes: [
        { name: '', maxSize: 3000 },
      ],
    },
  },

  filters: [
    {
      name: 'all',
      title: lang.label.allCapital,
      quickFilter: null,
    },
    {
      name: 'draft',
      title: lang.toProcess,
      quickFilter: {
        state: {
          type: 'set',
          values: [DRAFT],
        },
      },
    },
    {
      name: 'toAnalyze',
      title: lang.toAnalyze,
      quickFilter: {
        state: {
          type: 'set',
          values: [TO_ANALYZE],
        },
      },
    },
    {
      name: 'analyzeError',
      title: lang.analyzeError,
      quickFilter: {
        state: {
          type: 'set',
          values: [ANALYZE_ERROR],
        },
      },
    },
    {
      name: 'open',
      title: lang.open,
      quickFilter: {
        state: {
          type: 'set',
          values: [OPEN],
        },
      },
    },
    {
      name: 'paid',
      title: lang.paid,
      quickFilter: {
        state: {
          type: 'set',
          values: [PAID],
        },
      },
    },
    {
      name: 'partiallyPaid',
      title: lang.partiallyPaid,
      quickFilter: {
        state: {
          type: 'set',
          values: [PARTIALLYPAID],
        },
      },
    },
  ],
}
